export const BROWSE_CATEGORY_HEIGHT = 104;
